export const AUDIT_LOG_PAGE_SIZE = 12;

export const AUDIT_LOG_PAGE_GUIDE = [
  "Filtrez par utilisateur, action, type d'entité ou plage de dates.",
  "Cliquez sur une entrée pour voir le détail des métadonnées.",
];

export const AUDIT_LOG_PAGE_TIP =
  "Page en lecture seule, pour corriger une action, utilisez la fonction de correction propre au module concerné.";

export const AUDIT_LOG_PAGE_INTRO =
  "Historique complet des actions effectuées dans l'application.";

export const AUDIT_LOG_EMPTY_MESSAGE = "Aucune entrée trouvée.";
